function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.923 25.926c.766 0 1.387-.572 1.387-1.276v-6.422h4.163c.766 0 1.387-.571 1.387-1.276V1.638c0-.705-.621-1.276-1.387-1.276H7.499c-.766 0-1.387.571-1.387 1.276v15.314c0 .705.621 1.276 1.387 1.276h11.87l6.483 7.233c.264.294.657.465 1.071.465zM8.887 2.914h22.198v12.762h-5.55v5.42l-4.857-5.42H8.887Z",
    style: {
      strokeWidth: 1.45159
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "10.6667px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      fillOpacity: 1,
      stroke: "none"
    },
    x: 4.293,
    y: 39.485
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.293,
    y: 39.485,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "10.6667px",
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif Bold'"
    }
  }, "CHAT")));
};
export default SvgChat;